export const capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const isEmpty = (obj) => {
    if (!obj || obj.constructor !== Object) {
        return true;
    }
    return Object.entries(obj).length === 0;
};

/**
 * formatted (trailing 0's removed) version of the number formatter above
 *
 * e.g. 100 -> 100
 *      1234 -> 1.2k
 *      12345 -> 12.3k
 *      123456 -> 123.5k
 *      9999999 -> 10m
 *      10000000 -> 10m
 * @param {int} num
 * @returns {string}
 */

const matchRegex = /({{{COMPANY_AD_EMBEDED}}}|{{{COMPANY_AD_STANDALONE}}})/g;

export const stripAdPlaceholderText = (str) => str.replace(matchRegex, '');

// Flattens an array. d is the depth, use keyword Infinity to flatten it forever.
export function flatten(arr, d = 1) {
    return d > 0
        ? arr.reduce(
            (acc, val) => acc.concat(Array.isArray(val) ? flatten(val, d - 1) : val),
            []
        )
        : arr.slice();
}

const objToStr = (obj) => {
    let cls = '';
    cls += obj.map((k) => {
        if (k) return k;
        return '';
    });
    return cls;
};

const toValue = (mix) => {
    let y;
    let str = '';
    if (typeof mix === 'string' || typeof mix === 'number') {
        str += mix;
    } else if (typeof mix === 'object') {
        if (Array.isArray(mix)) {
            str += mix.map((k) => {
                y = toValue(mix[k]);
                if (y) {
                    return y;
                }
                return '';
            });
        }
    } else {
        str += objToStr(mix);
    }
    return str;
};

export const constructCn = (...args) => {
    let i = 0;
    let tmp;
    let str = '';
    while (i < args.length) {
        if (args[i]) {
            tmp = toValue(args[i]);
            if (tmp) {
                if (str !== '') str += ' ';
                str += tmp;
            }
        }
        i += 1;
    }
    return str;
};
